import { useSuspenseQuery } from "@apollo/client";
import { GET_MCP_CONNECTION } from "@/modules/ai/widgets/mcp-connection/api/get-mcp-connection";

export function useMcpConnection() {
  const { data } = useSuspenseQuery(GET_MCP_CONNECTION);

  return data.getMcpConnection;
}
